module.exports = __webpack_public_path__ + "static/media/women-fas-cat-3.fbd52efb.png";